import { Css } from "@homebound/beam";
import { camelCase } from "change-case";
import { Fragment } from "react";
import { useTradeScopeOfWorkQuery } from "src/routes/pdfs/TradeScopeOfWorkPdf.generated";
import { HasChildren } from "src/utils";
import { queryResult } from "src/utils/queryResult";
import { StringParam, useQueryParam } from "use-query-params";

export function TradeScopeOfWorkPdf() {
  const [changeEventLineItemIds] = useQueryParam("changeEventLineItemIds", StringParam);
  const id = changeEventLineItemIds?.split(",") ?? [];
  const query = useTradeScopeOfWorkQuery({ variables: { filter: { id } } });
  return queryResult(query, {
    data: ({ changeEventLineItems }) => {
      const lineItems = changeEventLineItems ?? [];
      if (lineItems.length === 0) return <Fragment />;
      return (
        <div css={Css.mb5.$} data-testid="specificationsLineItems">
          <h1 css={Css.gray800.fwb.xl2.m0.$} data-testid="title">
            Scope of Work - Specifications
          </h1>
          {lineItems.map((lineItem) => {
            const { id, displayName, quantity, unitOfMeasure, specifications, tradePartnerNote } = lineItem;
            return (
              <div key={id}>
                <div css={Css.md.fwb.mt2.$} data-testid="displayName">
                  {displayName}
                </div>
                <ul css={Css.listReset.add("listStyleType", "disc").add("padding", "revert").$}>
                  <TradeScopeOfWorkRow title="Quantity">
                    {quantity} {unitOfMeasure?.name}
                  </TradeScopeOfWorkRow>
                  <TradeScopeOfWorkRow title="Specifications">{specifications}</TradeScopeOfWorkRow>
                  <TradeScopeOfWorkRow title="Trade Note">{tradePartnerNote}</TradeScopeOfWorkRow>
                </ul>
              </div>
            );
          })}
        </div>
      );
    },
  });
}

type TradeScopeOfWorkRowProps = HasChildren & { title: string };
function TradeScopeOfWorkRow(props: TradeScopeOfWorkRowProps) {
  return (
    <li css={Css.my("5px").$} data-testid={props["data-testid"] ?? camelCase(props.title)}>
      <span css={Css.tdu.mr1.$}>{props.title}:</span>
      {props.children}
    </li>
  );
}
